










































import Vue from "vue";
import _ from "lodash";
import { Item } from "@/components/CartCommon/cart";
import IconHelp from "@/components/CartCommon/Common/Icons/IconHelp.vue";

export default Vue.extend({
  props: {
    item: Object as () => Item
  },
  components: {
    IconHelp,
  },
  data() {
    return {
      localQuantity: this.item.quantity,
      quantityOptions: this.item.unitsInStock,
    };
  },
  computed: {
    paperAndEGiftInCart(): boolean {
      return this.$store.state.hasPaperGift && this.$store.state.hasEGift;
    }
  },
  watch: {
    "item.quantity"() {
      this.localQuantity = this.item.quantity;
    },
    localQuantity() {
      this.$emit("quantityChanged", this.localQuantity);
    }
  },
  methods: {
    onDeleteButtonClicked() {
      if (window.confirm('カートから削除しますか？')) {
        this.$emit("delete");
      }
    }
  }
});
